<template>
  <div :class="componentClassName">
    <div class="m-holiday-setting-item__header">
      <div class="m-holiday-setting-item__title">休日{{ itemNumber }}</div>
      <div class="m-holiday-setting-item__remove-button">
        <a-button
          :id="'delete_' + itemNumber"
          variant="round"
          size="small"
          label="削除"
          color="grey"
          icon="trash"
          :inline="true"
          @click="handleItemRemoveClick"
        />
      </div>
    </div>
    <div class="m-holiday-setting-item__fields">
      <m-form-input label="タイプ">
        <a-select-field id="type" v-model="type" :options="typeOptions" @change="handleChange" />
      </m-form-input>
      <m-form-input :label="label">
        <a-calendar-field
          :id="'holiday_' + itemNumber"
          v-model="holiday"
          :min-date="minDate"
          :placeholder="label"
          @change="handleChange"
        />
      </m-form-input>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import ACalendarField from '@/components/atoms/calendar-field';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE, HOLIDAY_TYPE } from '@/libs/constants';

export default {
  name: 'm-holiday-setting-item',
  components: {
    AButton,
    MFormInput,
    ASelectField,
    ACalendarField,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: Object,
      default: null,
    },
  },
  emits: ['remove', 'update:modelValue', 'change'],
  data() {
    return {
      type: '',
      typeOptions: [
        {
          label: '休業日',
          value: HOLIDAY_TYPE.NORMAL,
        },
        {
          label: '例外日',
          value: HOLIDAY_TYPE.EXCEPTION,
        },
      ],
      holiday: null,
      minDate: dayjs().tz(DEFAULT_TIMEZONE).format(),
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-holiday-setting-item');
      return `${baseClassName} ${this.class}`.trim();
    },
    itemNumber() {
      return this.itemIndex + 1;
    },
    label() {
      return this.type === HOLIDAY_TYPE.EXCEPTION ? '例外日' : '休業日';
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    } else {
      this.type = HOLIDAY_TYPE.NORMAL;
    }
  },
  methods: {
    handleItemRemoveClick() {
      this.$emit('remove', this.itemIndex);
    },
    setCurrentValue(val) {
      this.type = val.type || HOLIDAY_TYPE.NORMAL;
      this.holiday = val.value;
    },
    emitEvent() {
      const modelValue = {
        type: this.type,
        value: this.holiday,
      };
      this.$emit('update:modelValue', cloneDeep(modelValue));
      this.$emit('change', cloneDeep(modelValue));
    },
    handleChange() {
      this.emitEvent();
    },
  },
};
</script>
